<app-auth-shell>
  <form class="auth-card" (ngSubmit)="handleSubmit()">
    <div class="auth-card__header">
      <span class="auth-card__ornament" aria-hidden="true">⟡ ❖ ⟡</span>
      <h1>Welcome Back</h1>
      <p>Login to continue your spiritual journey</p>
    </div>

    <div class="auth-card__tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="auth-card__tab"
        [class.auth-card__tab--active]="loginMode() === 'password'"
        [attr.aria-selected]="loginMode() === 'password'"
        (click)="setLoginMode('password')"
      >
        <span aria-hidden="true">🔒</span> Password Login
      </button>
      <button
        type="button"
        role="tab"
        class="auth-card__tab"
        [class.auth-card__tab--active]="loginMode() === 'otp'"
        [attr.aria-selected]="loginMode() === 'otp'"
        (click)="setLoginMode('otp')"
      >
        <span aria-hidden="true">📱</span> OTP Login
      </button>
    </div>

    @if (loginMode() === 'password') {
      <div class="auth-card__field">
        <label for="login-email">Email Address</label>
        <div class="auth-card__input-wrapper">
          <span aria-hidden="true">✉️</span>
          <input
            id="login-email"
            type="email"
            name="email"
            placeholder="Enter your email address"
            [(ngModel)]="email"
            required
          />
        </div>
      </div>

      <div class="auth-card__field">
        <label for="login-password">Password</label>
        <div class="auth-card__input-wrapper">
          <span aria-hidden="true">🔒</span>
          <input
            id="login-password"
            [type]="passwordVisible() ? 'text' : 'password'"
            name="password"
            placeholder="Enter your password"
            [(ngModel)]="password"
            required
          />
          <button type="button" class="auth-card__eye-toggle" (click)="togglePasswordVisibility()" [attr.aria-label]="passwordVisible() ? 'Hide password' : 'Show password'">
            {{ passwordVisible() ? '🙈' : '👁️' }}
          </button>
        </div>
      </div>

      <div class="auth-card__options">
        <label class="auth-card__remember">
          <input type="checkbox" name="rememberMe" [(ngModel)]="rememberMe" />
          Remember Me
        </label>
        <a [routerLink]="routes.AUTH.FORGOT_PASSWORD" class="auth-card__forgot">Forgot Password?</a>
      </div>

      @if (errorMessage()) {
        <p class="auth-card__error" role="alert">{{ errorMessage() }}</p>
      }

      <button type="submit" class="auth-card__submit" [disabled]="loading()">
        <span aria-hidden="true">⇥</span>
        {{ loading() ? 'Logging in…' : 'Login' }}
      </button>
    } @else {
      <div class="auth-card__field">
        <p class="auth-card__step-label">1. Enter your phone number or email</p>
        <app-country-phone-input
          [(country)]="otpCountry"
          [(phoneNumber)]="otpPhone"
          placeholder="Enter your phone number"
        ></app-country-phone-input>
        <p class="auth-card__hint">We will send you a 6-digit verification code</p>
        @if (isDummyMode) {
          <p class="auth-card__demo-hint">Demo: 9036087945 / 9108078692 · OTP 123456</p>
        }
      </div>

      @if (otpSent()) {
        <div class="auth-card__field">
          <p class="auth-card__step-label">2. Enter 6-digit OTP</p>
          <app-otp-input [(code)]="otpCode" (resend)="sendOtp()"></app-otp-input>
        </div>
      }

      @if (otpError()) {
        <p class="auth-card__error" role="alert">{{ otpError() }}</p>
      }

      <button type="submit" class="auth-card__submit" [disabled]="otpSubmitDisabled()">
        <span aria-hidden="true">{{ otpSent() ? '🔒' : '➤' }}</span>
        {{ otpButtonLabel() }}
      </button>
    }

    <div class="auth-card__divider">
      <span>or continue with</span>
    </div>

    <div class="auth-card__social">
      <button type="button" class="auth-card__social-btn">
        <span class="auth-card__social-icon auth-card__social-icon--google" aria-hidden="true">G</span>
        Google
      </button>
      <button type="button" class="auth-card__social-btn">
        <span aria-hidden="true">🍎</span>
        Apple
      </button>
    </div>

    <p class="auth-card__footer-link">
      Don't have an account? <a [routerLink]="routes.AUTH.REGISTER">Create Account</a>
    </p>
  </form>
</app-auth-shell>
